import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const QUERY_DATE_SCHEMA = Object.freeze({
  MONTH: null, // number
  QUARTER: null, // number
  YEAR: null, // number
});
export const RECORD = generateSchema(QUERY_DATE_SCHEMA);
export const KEYS: any = generateKeys(QUERY_DATE_SCHEMA);

export class QueryDate extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get month(): number {
    return this.get(KEYS.MONTH);
  }

  get quarter(): number {
    return this.get(KEYS.QUARTER);
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }
}
